import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DocumentsModalConfig } from '../../models/documents-modal-config';
import {
  ButtonDirective,
  DialogRef,
  MODAL_DATA,
  ModalCloseButtonDirective,
  ModalCloseTypesEnum,
  ModalComponent,
  ModalContentDirective,
  ModalTitleDirective,
  SizeScheme
} from '@bioreferencehealth/ui-kit';
import { DocumentsViewerComponent } from '../documents-viewer/documents-viewer.component';

@Component({
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ModalComponent,
    ModalTitleDirective,
    ModalContentDirective,
    ModalCloseButtonDirective,
    ButtonDirective,
    DocumentsViewerComponent
  ]
})
export class DocumentsComponent {
  private readonly data = inject<DocumentsModalConfig>(MODAL_DATA);
  private readonly dialogRef = inject(DialogRef);

  public documentsHeading = this.data.header;
  public documents = this.data.documents;

  public onCloseDialog($event: ModalCloseTypesEnum): void {
    this.dialogRef.close($event);
  }

  protected readonly SizeScheme = SizeScheme;
}
